// ————————————————————————————————————————————— DOC. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "api.insert_loadedAsset", inline: true };
const loggerMsgs = {
  eventStart: ["Preloader", "API", "insert_loadedAsset"],
  noAssetData: ["Preloader", "API", "insert_loadedAsset", "no asset data provided"],
  noFileID: ["Preloader", "API", "insert_loadedAsset", "no file ID provided"],
  noImgEl: (FILEID) => [`no img elements found with matching data-file-id ${FILEID}`],
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function insert_loadedAsset(ASSETDATA) {
  if (!ASSETDATA) return this.logger("error", loggerMsgs.noAssetData, "error", logArgs);

  // Setup...
  const { uuid, type, objectURL } = ASSETDATA;
  this.logger("event", loggerMsgs.eventStart, "event", logArgs);

  // Guard...
  if (!uuid) return this.logger("error", loggerMsgs.noFileID, "error", logArgs);

  if (type == "image") {
    ////////////////
    // Img. files //
    ////////////////

    // Find img elements with matching data-file-id...
    const imgEls = document.querySelectorAll(`img[data-file-id="${uuid}"]`);

    // Guard...
    if (!imgEls || !imgEls.length) return this.logger("warning", loggerMsgs.noImgEl(uuid), "warning", logArgs);

    // Replace src. with file object URL...
    imgEls.forEach((el) => {
      el.src = objectURL;
      el.setAttribute("data-preloaded", "true");
      el.setAttribute("data-is-hidden", "false");
    });
  }
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
